import style from "./style.module.scss";
import Button from "@mui/material/Button";
import { Box, Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { getTenant } from "../../theme";
import { checkEmptyObj, checkIf } from "../../utils";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function Footer() {
  const { t } = useTranslation("footer");
  const tenant = getTenant();
  const user = useSelector((state: RootState) => state.user);

  const getBrandName = () => {
    switch (tenant.name) {
      case "healthy-kitchen":
        return "Healthy Kitchen";
      case "second-bite":
        return "Second Bite";
      case "diet-center":
        return "Diet Center";
      case "low-cal":
        return "Low Cal";
      case "high-protein":
        return "High Protein";
      default:
        return "Rejeem";
    }
  };
  return (
    <Box className={style.footer_wrapper} sx={{ width: 1 }}>
      <Container className={style.footer} maxWidth="lg">
        <Grid
          item
          xs={12}
          sx={{ height: "106px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <div className={style.logo_container}>
            <Link to={`/`}>
              <Box
                sx={{
                  backgroundImage: `url(../../${tenant.name}/logoHorizontal.svg)`,
                  height: `${tenant.logo.height / 1.5}px`,
                  width: `${tenant.logo.width / 1.5}px`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                }}
              />
            </Link>
          </div>
          <Box sx={{ display: "flex", gap: "48px", alignItems: "center" }}>
            <Box sx={{ display: "flex", gap: "12px", justifyContent: ["center", "flex-start"] }}>
              <Box
                sx={{
                  height: "40px",
                  width: "135px",
                  backgroundImage: "url(../../images/download-android.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  cursor: "pointer",
                }}
                onClick={() => window.open(tenant.android, "_blank")}
              ></Box>
              <Box
                sx={{
                  height: "40px",
                  width: "135px",
                  backgroundImage: "url(../../images/download-ios.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  cursor: "pointer",
                }}
                onClick={() => window.open(tenant.ios, "_blank")}
              ></Box>
            </Box>
            <div className={style.menu_container}>
              <ul>
                {tenant.name === "rejeem" && (
                  <li onClick={() => window.scrollTo(0, 0)}>
                    <Link to={`/about`}>{t("aboutUs")}</Link>
                  </li>
                )}

                <li onClick={() => window.scrollTo(0, 0)}>
                  {tenant.name === "rejeem" ? (
                    <Link to={`/partners`}>{t("partners")}</Link>
                  ) : (
                    <Link to={`/plans`}>{t("plans")}</Link>
                  )}
                </li>

                {/* <li>Dietitian</li> */}
                {/* <li>Help</li> */}
                <li onClick={() => window.scrollTo(0, 0)}>
                  <Link to={`/contact`}>{t("contact")}</Link>
                </li>
              </ul>
            </div>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ height: "84px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <div className={style.copyright}>
            {t("copyright", {
              year: moment().year(),
              brandName: getBrandName(),
            })}
          </div>

          <div className={style.submenu}>
            <ul>
              <li onClick={() => window.scrollTo(0, 0)}>
                <Link to="/privacy">{t("privacyPolicy")}</Link>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <Link to="/support">{t("support")}</Link>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <Link to="/terms-and-conditions">{t("termsAndConditions")}</Link>
              </li>
            </ul>
          </div>
        </Grid>
      </Container>
    </Box>
  );
}
